import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_GREY_12 } from "shared/theme/colors";
import { StyledContainer, StyledDot } from "./styled";

type Props = {
  color: string;
  title: string;
};

const StatusChip: FC<Props> = ({ color, title }) => {
  return (
    <StyledContainer>
      <StyledDot bgColor={color} />
      <Typography variant="bodySMedium" color={COLOR_GREY_12}>
        {title}
      </Typography>
    </StyledContainer>
  );
};

export default StatusChip;
